<template>
  <div
    class="tickets-box"
    :style="item.status === 1 ? 'background: #3d95ff;' : 'background: #d2d2d2;'"
  >
    <div class="tickets-left">
      <p class="ticket-name">{{ tickets.ticketName }}</p>
      <p>{{ tickets.price }}元</p>
      <div
        class="Qr"
        :id="`WXqrcode${item.id}`"
        :ref="`WXqrcode${item.id}`"
      ></div>
    </div>
    <div class="tickets-content">
      <p class="ticket-title">{{ tickets.title }}</p>
      <p style="font-size: 14px">
        {{ tickets.beginTime }} - {{ tickets.endTime }}
      </p>
      <p style="font-size: 14px">
        <span style="margin-right: 30px">{{ item.name }}</span>
        <span>{{ item.phone }}</span>
      </p>
    </div>
    <img
      v-if="item.status === 2"
      class="tickets-img"
      src="@/assets/img/qietu/cancel.png"
      alt=""
    />
    <p class="number">No.{{ item.id | fillZero }}</p>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  props: {
    meetingId: {
      type: String,
      required: true,
    },
    tickets: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  filters: {
    fillZero: function (id) {
      return (Array(10).join(0) + id).slice(-10);
    },
  },
  created() {
    // 使用$nextTick确保数据渲染
    this.$nextTick(() => {
      this.qr = new QRCode("WXqrcode" + this.item.id, {
        width: 64,
        height: 64,
        text: this.$global.url1 + `meetingDetails?type=8&id=${this.meetingId}`, // 二维码内容
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.tickets-box {
  position: relative;
  margin: 0 auto 26px;
  padding-left: 164px;
  padding-right: 50px;
  width: 885px;
  height: 179px;
  // border: 1px solid #eeeeee;
  border-radius: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  .tickets-left {
    position: absolute;
    top: 0;
    left: 0;
    padding: 15px 10px 0;
    width: 123px;
    height: 179px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 10px 0 0 10px;
    text-align: center;
    p {
      font-size: 18px;
      line-height: 36px;
      color: #333333;
    }
    .Qr {
      margin: 14px auto 0;
      width: 64px;
      height: 64px;
    }
    .ticket-name {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .tickets-content {
    padding-top: 20px;
    font-size: 24px;
    color: #ffffff;
    line-height: 36px;
    .ticket-title {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .number {
    position: absolute;
    top: 28px;
    right: 16px;
    font-size: 14px;
    color: #ffffff;
    writing-mode: vertical-rl;
    letter-spacing: 1px;
  }
  .tickets-img {
    position: absolute;
    top: 32px;
    right: 93px;
    width: 126px;
    height: 109px;
  }
}
</style>